export default __webpack_public_path__ + "static/media/logo.aaae7747.svg";